import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../constant/commonButton";
import { useNavigate } from "react-router-dom";
import { styles } from "../components/LoginStyles";

const LogoutDialog = ({ open, onConfirm }) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        <IconButton aria-label="close" onClick={handleCancel} sx={styles.closeIcon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body1">Are you sure you want to logout?</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", marginBottom: "20px" }}>
        <CustomButton
          text="Ok"
          size="XtraSmall"
          onClick={onConfirm}
          buttonStyle="styledButton"
        />
        <CustomButton
          text="Cancel"
          variant="outlined"
          size="XtraSmall"
          onClick={handleCancel}
          buttonStyle="style3"
        />
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
